// extracted by mini-css-extract-plugin
export default {"Register":"kyc_Register__xSBKZ","details":"kyc_details__kxrOy","section":"kyc_section__holeH","Button":"kyc_Button__jOWeW","Bottom":"kyc_Bottom__te-DR"};